import {
  getAccountsAction,
  getAccountsFailAction,
  getAccountsSuccessAction,
} from '../ecom.actions';
import { Account } from '../interfaces';
import { createReducer, Action, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface State extends EntityState<Account> {
  selectedId: string;
  isLoading: boolean;
}

export function selectId(a: Account): string {
  return a.name;
}

export function sortByName(a: Account, b: Account): number {
  return a.name.localeCompare(b.name);
}

export const adapter: EntityAdapter<Account> = createEntityAdapter<Account>({
  selectId,
  sortComparer: sortByName,
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  isLoading: false,
});

const accountReducer = createReducer(
  initialState,
  on(getAccountsAction, (state) => ({ ...state, isLoading: true })),
  on(getAccountsSuccessAction, (state, action) => ({
    ...state,
    ...adapter.setAll(action.accounts, state),
    isLoading: false,
  })),
  on(getAccountsFailAction, (state) => ({ ...state, isLoading: false })),
);

export function reducer(state: State | undefined, action: Action) {
  return accountReducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
